export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/event/index.js